import { Outlet } from 'react-router-dom';

export default function RevisionLayout() {
  return (
    <div className='w-full min-h-screen bg-white'>
      <Outlet />
    </div>
  );
}
